<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-form-item label="小程序openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="创建日期: " style="margin:0 20px 0 0" size="small">
        <el-input v-model="listQuery.create_time" placeholder="请输入" clearable></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="状态:" style="margin: 0px 20px 0 0" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>-->
      <el-button type="primary" @click="search" size="small" v-waves style="margin: 0 0px 10 0">搜索</el-button>
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="img_head" slot-scope="{ row }">
          <el-image
            class="elImage"
            :src="row.img_head"
            :preview-src-list="[row.img_head]"
            v-if="row.img_head"
          ></el-image>
          <div v-else>暂未上传</div>
        </template>

        <template slot="gzh_openid" slot-scope="{ row }">
          <span v-if="row.gzh_openid">{{row.gzh_openid}}</span>
          <div v-else>暂未登录公众号</div>
        </template>


        <template slot="phone" slot-scope="{ row }">
          <span v-if="row.phone">{{row.phone}}</span>
          <div v-else>暂未授权手机号</div>
        </template>


        <template slot="disable" slot-scope="{ row }">
          <el-tag v-if="row.disable === 1" type="danger" effect="dark" size="mini">异常用户</el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">正常用户</el-tag>
        </template>
        <!-- <template slot="state" slot-scope="scope">
           <FillingStatus :value="scope.row" />
        </template>
        <template slot="fillRate" slot-scope="scope">
          <Percentage :value="scope.row"></Percentage>
        </template>-->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button
              size="mini"
              type="text"
              @click="handleDisable(row)"
              primary
            >{{ row.disable === 1 ? "启用" : "禁用" }}</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="140px">
        <el-form-item label="用户姓名" required>
          <el-input v-model="dialogForm.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="dialogForm.phone" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import {
  selectUser,
  deleteUser,
  disableUser,
  updateApi
} from "@/services/mall/user";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],

      dialogFormVisible: false,
      inpitTypeName: "",
      dialogForm: {}
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader
  },
  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectUser(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 编辑 */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (!this.dialogForm.username) {
        this.$message.error("请填写必填字段");
        return;
      }
      updateApi({
        id: this.dialogForm.id,
        phone: this.dialogForm?.phone,
        username: this.dialogForm?.username
      }).then(resp => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.dialogFormVisible = false;
          this.getListData();
        }
      });
    },
    /* 禁用 */
    handleDisable(row) {
      this.$confirm(
        `确定${row.disable === 1 ? "启用" : "禁用"}手机号为"${
          row.phone
        }"的用户吗?`,
        "禁用",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(res => {
        disableUser({ id: row.id, disable: row.disable === 1 ? 0 : 1 }).then(
          res => {
            if (res.code === 200) {
              this.getListData();
              this.$message({
                type: "success",
                message: "操作成功!"
              });
            }
          }
        );
      });
    },
    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除手机号为"${row.phone}"的用户吗?`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteUser({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.elImage {
  width: 50px;
}
</style>
